// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { COLORS } from 'admin/core/theme';
import { StyledCodeEditor } from 'admin/common/styles/CodeEditor';

export const MassMailingFormFooter = styled.div`
  margin-top: 24px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;

  .pul-popover__target {
    margin-left: 16px;
  }
`;

export const FooterButtonGroup = styled.div`
  display: flex;
  gap: 16px;
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  padding: 0 15px;
  color: ${COLORS.RED};
`;

export const SelectWithDescription = styled.div`
    margin-bottom: 8px;

    .pul-section-item {
        margin-bottom: 0;
    }
`;

export const ResizableCodeEditor = styled(StyledCodeEditor)`
    .CodeMirror {
        resize: both;
    }
`;

export const ExampleTemplateCodeEditor = styled(StyledCodeEditor)`
    margin: 8px 0;
`;

export const NoWrapCode = styled.code`
    white-space: nowrap;
`;

export const PreviewRecipientRow = styled.div`
    margin-bottom: 16px;
`;

export const PreviewSubject = styled.div`
    margin-bottom: 8px;
    padding: 8px;
    background-color: ${COLORS.GREY_20};
    border-radius: 4px;
    overflow-wrap: break-word;
`;

export const PreviewIframe = styled.iframe`
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: 420px;
    border: 1px solid ${COLORS.GREY_40};
    border-radius: 4px;
    overflow: auto;
`;
